import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useApi } from '@backstage/core-plugin-api';
import React, { useEffect, useState } from "react"
import { CheckmarxComponent } from "../Checkmarx/Checkmarx"
import { SonarQubeComponent } from "../SonarQube/SonarQube"
import { testData } from "./types"


const ProductSecurity = ({ appName }: { appName?: string }): JSX.Element => {
    const catalogApi = useApi(catalogApiRef);
    const [catalogEntities, setCatalogEntities] = useState<Awaited<ReturnType<typeof catalogApi.getEntities>>['items']>();

    useEffect(() => {
        let isMounted = true;

        catalogApi.getEntities()
            .then(response => {
                if (isMounted) {
                    setCatalogEntities(response.items);
                }
            })
            .catch(() => {
                if (isMounted) {
                    setCatalogEntities([]);
                }
            });

        return () => {
            isMounted = false;
        };
    }, [catalogApi]);

    const data={...testData, appName, catalogEntities};
    return (<div>
        <CheckmarxComponent data={data} />
        <SonarQubeComponent data={data} />

    </div>)

}

export {ProductSecurity}